import type { Prototype } from "../prototype-types";

export const willChartrandPrototypes: Prototype[] = [
  {
    id: "wc-brand-page-top-reordered-nux",
    name: "PDP Top Reordered NUX",
    path: "/wc/brand-page-top-reordered-nux",
    description:
      "PDP PRODUCT_SALES_INSIGHT badge gated by TOP_REORDERED_LIST_PAGE_XP_260924. Treatment turns the badge into a link to the ranked list, called out by an anchored new-feature coachmark.",
    owner: "Will Chartrand",
    createdAt: "2026-11-02",
    lastUpdated: "2026-11-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    project: "Top Reordered List Page",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/awe-top-reordered-list-page.png",
  },
  {
    id: "wc-expanded-collections",
    name: "Expanded Collections",
    path: "/wc/expanded-collections",
    description:
      "Reimagine the brand page Collections tab as one collection per row",
    owner: "Will Chartrand",
    createdAt: "2026-06-18",
    lastUpdated: "2026-06-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/3da2fe7155138167a53235f6215301f991312376b1c95ce2de3459ba40254223.png",
    creationTool: "claude-code",
  },
  {
    id: "wc-pdp-mask-safety-disclaimer",
    name: "PDP Mask Safety Disclaimer",
    path: "/wc/pdp-mask-safety-disclaimer",
    description:
      "Where the face-mask safety disclaimer should live in the redesigned PDP info hierarchy — its own accordion category vs. folded into an existing info section",
    owner: "Will Chartrand",
    createdAt: "2026-08-12",
    lastUpdated: "2026-08-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.faire.com/fastly/f967a9d1ce423a51c0c87339effbb59cb2e20ff76e296a7bcdf982e45f50c080.png",
  },
  {
    id: "wc-mini-pdp-modals",
    name: "Mini PDP Modals",
    path: "/wc/mini-pdp-modals",
    description: "Quick-view mini PDP in a modal opened from a product grid, so shoppers can scan product details without leaving the grid",
    owner: "Will Chartrand",
    createdAt: "2026-09-10",
    lastUpdated: "2026-09-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/wc-mini-pdp-modals.png",
  },
];
